var render = function render(){var _vm=this,_c=_vm._self._c;return _c('window',{attrs:{"title":"Events"}},[_c('vue-chart',{attrs:{"chart-type":"BarChart","chart-events":_vm.chartEvents,"columns":_vm.columns,"rows":_vm.rows,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }